export const SCROLL_KEY = 'scroll-to';
export const scrollOnEvent = (eventBus) => {
    eventBus.$on(SCROLL_KEY, (element, behavior, block, inline) => {
        if (!element)
            return;
        process.nextTick(function () {
            element.scrollIntoView({ behavior: behavior, block: block, inline: inline });
        });
    });
};
export const emitScrollToElement = (eventBus, element, behavior = 'smooth', block = 'end', inline = 'nearest') => {
    eventBus.$emit(SCROLL_KEY, element, behavior, block, inline);
};
